<p-toast position="bottom-center"></p-toast>
<p-confirmDialog></p-confirmDialog>

<p-dialog header="Upload New Software" [(visible)]="showUploadModal" [modal]="true" [closable]="true" [dismissableMask]="true" [style]="{width: '800px', height: '800px'}" (onHide)="onBack()">
  <div>
    <div class="upload-modal-content" style="height: 690px;">
      <ng-container *ngIf="!showFormStep">
        <div
          class="drag-drop-zone"
          (drop)="onFileDrop($event)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          [ngClass]="{ 'drag-over': isDragOver }"
          style="height: 690px;"
        >
          <div style="text-align: center; color: #888;">
            <i class="pi pi-upload" style="font-size: 2.5rem; margin-bottom: 1rem;"></i>
            <p>Drag & drop your file here, or click to select</p>
            <p>{{ fileTypeMessage }}</p>
            <input type="file" (change)="onFileSelect($event)" style="display: none;" #fileInput [accept]="allowedFileTypes" />
            <button pButton type="button" label="Choose File" (click)="fileInput.click()" style="margin-top: 1rem;"></button>
          </div>
        </div>
        <div *ngIf="uploadedFile" class="selected-file">
          <strong>Selected file:</strong> {{ uploadedFileName }}
        </div>
        
        <div *ngIf="uploadedFile && isSpFile()" style="margin-top: 1rem; width: 100%">
          <div class="form-group">
            <label for="sha256Input" style="font-weight: 600; margin-bottom: 0.5rem; display: block;">
              Expected SHA256 Hash <span style="color: red;">*</span>
            </label>
            <input 
              id="sha256Input"
              type="text" 
              [(ngModel)]="userProvidedSha256" 
              (input)="onSha256Input()"
              placeholder="Enter the expected SHA256 hash of the file"
              class="p-inputtext p-component"
              style="width: 100%; font-family: monospace; font-size: 12px;"
              maxlength="64"
            />
            <div *ngIf="!userProvidedSha256 && !sha256ValidationError" style="margin-top: 0.5rem; height: 22px;"></div>
            <div *ngIf="sha256ValidationError" style="color: #e24c4c; margin-top: 0.5rem; font-size: 14px; height: 22px;">
              <i class="pi pi-exclamation-triangle" style="margin-right: 0.5rem;"></i>
              {{ sha256ValidationError }}
            </div>
            <div *ngIf="calculatedSha256 && !sha256ValidationError && userProvidedSha256" 
                 style="color: #22c55e; margin-top: 0.5rem; font-size: 14px; height: 22px;">
              <i class="pi pi-check-circle" style="margin-right: 0.5rem;"></i>
              SHA256 verification successful
            </div>
          </div>
        </div>
        
        <div *ngIf="uploadedFile" style="text-align: right; margin-top: 1.5rem;">
          <button 
            pButton 
            type="button" 
            label="Next >" 
            [disabled]="!isNextButtonEnabled"
            (click)="onNext()">
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="showFormStep">
        <form style="width: 500px">
          <div class="form-group" style="margin-bottom: 1rem;">
            <label>Selected Family</label>
            <input type="text" [value]="selectedFamilyForUpload" class="p-inputtext p-component" readonly />
          </div>
          <div class="form-group" style="margin-bottom: 1rem;">
            <label>Model</label>
            <input type="text" [(ngModel)]="form.model" name="model" required class="p-inputtext p-component" [readonly]="true" />
          </div>
          <div class="form-group" style="margin-bottom: 1rem;">
            <label>Version Number</label>
            <input type="text" [(ngModel)]="form.versionNumber" name="versionNumber" required class="p-inputtext p-component" [readonly]="true" />
          </div>
          <div class="form-group" style="margin-bottom: 1rem;">
            <label>Description</label>
            <textarea [(ngModel)]="form.description" name="description" class="p-inputtext p-component"></textarea>
          </div>
          <div style="text-align: right; margin-top: 1.5rem; display: flex; justify-content: space-between;">
            <button pButton type="button" label="Back" (click)="onBack()" [disabled]="uploading"></button>
            <button pButton type="button" [disabled]="!isFormValid() || uploading" (click)="onUpload()">
              <ng-container *ngIf="!uploading">Upload</ng-container>
              <ng-container *ngIf="uploading">
                <p-progressSpinner 
                  [style]="{'width': '16px', 'height': '16px', 'margin-right': '0.5rem'}"
                  strokeWidth="4">
                </p-progressSpinner>
                Uploading...
              </ng-container>
            </button>
          </div>
        </form>
      </ng-container>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="showEditModal" [modal]="true" [closable]="true" [dismissableMask]="true" [style]="{width: '500px', height: '150px'}" class="edit-modal-dialog" header="Edit {{ editingValue === 'supportedMachines' ? 'supported machines' : editingValue }}">
  <div style="position: relative;">
    <div class="upload-modal-content">
      <form style="width: 450px" (ngSubmit)="onEditFormSubmit()">
        <div class="form-group" style="margin-bottom: 1rem;">
          <input type="text" [(ngModel)]="editForm.editing" name="editing" required class="p-inputtext p-component" [disabled]="editing" />
        </div>
      </form>
    </div>
    <div *ngIf="editing" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255,0.7); display: flex; align-items: center; justify-content: center; z-index: 10;">
      <p-progressSpinner styleClass="custom-spinner" strokeWidth="4" fill="#eeeeee" animationDuration="1s" [style]="{width: '40px', height: '40px'}"></p-progressSpinner>
    </div>
  </div>
</p-dialog>

<div class="page-title" style="display: flex; align-items: center; justify-content: space-between;">
  <div>
    <h3 style="padding-top: 1rem; padding-bottom: 1rem;">
      Software Updates
    </h3>
  </div>
  <div style="display: flex; gap: 1rem;">
    <button pButton type="button" (click)="refreshSoftwareList()" [disabled]="loading" class="p-button-outlined">
      <ng-container *ngIf="!loading">
        <i class="pi pi-refresh"></i>
      </ng-container>
      <ng-container *ngIf="loading">
        <p-progressSpinner styleClass="custom-spinner" strokeWidth="4"  fill="#ffffff" animationDuration="1s" [style]="{width: '16px', height: '16px', 'margin': 'initial'}"></p-progressSpinner>
      </ng-container>
    </button>
    <button *ngIf="canManageSoftware" pButton type="button" (click)="op.toggle($event)" #menuButton [disabled]="loadingFamilyMenu" style="width: 250px;">
      <ng-container *ngIf="!loadingFamilyMenu">
        <i class="pi pi-plus" style="margin-right: 0.5rem;"></i>
        Upload New Software
        <i class="pi pi-chevron-down" style="margin-left: 0.5rem;"></i>
      </ng-container>
      <ng-container *ngIf="loadingFamilyMenu">
        <p-progressSpinner styleClass="custom-spinner" strokeWidth="4" fill="#ffffff" animationDuration="1s" [style]="{width: '16px', height: '16px', 'margin-right': '0.5rem', 'margin': 'initial'}"></p-progressSpinner>
        Loading families...
      </ng-container>
    </button>
    <p-menu #op [model]="familyMenuItems" [popup]="true"></p-menu>
  </div>
</div>

<p-card>
  <app-besharp-table
    [tableItems]="datasource"
    [totalRecords]="dataSourceLength"
    [lazyMode]="true"
    [loading]="loading"
    [debounceSearchTime]="300"
    [idColumnDef]="'id'"
    [tableDefinitions]="tableDefinition"
    [actionDefinitions]="actionDefinition"
    [globalFilterFields]="globalFilterFields"
    [actionTitle]="''"
    [tableSize]="eBesharpTableSize.Small"
    [defaultActive]="'id'"
    [defaultDirection]="-1"
    [paginator]="true"
    [pageRows]="pageRows"
    [pageRowsOptions]="[5, 10, 20]"
    [showCurrentPageReport]="true"
    [showSearchInput]="true"
    [showClearFiltersButton]="true"
    [showExportButton]="true"
    [showStripes]="true"
    [showGridLines]="false"
    [rowOverEffect]="true"
    (onPageChange)="onAssignedPageChange($event)"
    (onSortChange)="assignedSortChangedEvent($event)"
    (onClearFilters)="clearAssignedFilters()"
    (onColumnFilter)="onColumnFilter($event)"
    (onGlobalSearch)="onGlobalSearch($event)"
    (onEditClickEvent)="editColumnClicked($event)"
  />
</p-card>
